<template>
  <v-sheet
    v-if="tagExplanations.length"
    color="strong"
    class="d-flex flex-wrap flex-column flex-md-row pa-3"
    style="justify-content: center; align-items: start"
  >
    <div
      v-for="(tagExplanation, index) in tagExplanations"
      :key="index"
      class="ma-2"
    >
      <AppShowCompetitionTag :key="index" :competition-tag="tagExplanation" />
      {{ tagExplanation.text }}
    </div>
  </v-sheet>
</template>
<script>
import { defineComponent, toRefs, computed } from "vue";
import gql from "fraql";
import { useTranslation } from "i18next-vue";

import AppShowCompetitionTag from "./AppShowCompetitionTag.vue";

export default defineComponent({
  name: "AppShowCompetitionTagExplanations",
  components: { AppShowCompetitionTag },
  props: {
    competitions: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { competitions } = toRefs(props);
    const { t } = useTranslation();
    const tagExplanations = computed(() => {
      return [
        {
          display: competitions.value.some(
            c =>
              c.resultsUnlisted &&
              c.allowedMutations.includes("competitionUpdateResultsUnlisted")
          ),
          text: t(
            "common:competition.resultsUnlisted.footnote.text",
            "Results unlisted - invisible for users"
          ),
          icon: "$iconEyeSlash",
          style: {
            color: "black",
            class: "bg-transparent"
          }
        },

        {
          display: competitions.value.some(c => c.isHighlighted),
          text: t(
            "common:competition.isHighlighted.footnote.text",
            "Important competition"
          ),
          icon: "$iconStar",
          style: {
            color: "star",
            class: ""
          }
        },

        {
          display: competitions.value.some(c => c.isGrandPrix),
          text: t(
            "common:competition.isGrandPrix.footnote.text",
            "A Grand Prix competition"
          ),
          iconText: t("common:competition.isGrandPrix.label", "GP"),
          style: {
            class: "bg-accent text-white"
          }
        },

        {
          display: competitions.value.some(c => c.isCupFinal),
          text: t("common:competition.isCupFinal.footnote.text", "Cup final"),
          icon: "$iconTrophy",
          style: {
            color: "black",
            class: "bg-transparent"
          }
        },

        {
          display: competitions.value.some(c =>
            (c.displayChips ?? []).includes("FeiEventUsingInvitationSystem")
          ),
          text: t(
            "common:competition.isInvitationSystemEvent.footnote.text",
            "Event using the Invitation System "
          ),
          iconText: t("common:competition.isInvitationSystemEvent.label", "IS"),
          style: {
            class: "bg-competitionInvitationSystemTag text-white"
          }
        },

        {
          display: competitions.value.some(c =>
            (c.displayChips ?? []).includes(
              "FeiEventWithStandardEntryProcedure"
            )
          ),
          text: t(
            "common:competition.standardEntryProcedure.footnote.text",
            "Event with standard entry procedure"
          ),
          iconText: t("common:competition.standardEntryProcedure.label", "SE"),
          style: {
            class: "bg-competitionStandardProcedureTag text-white"
          }
        },

        {
          display: competitions.value.some(c =>
            (c.displayChips ?? []).includes("FeiEventWithUnlimitedEntries")
          ),
          text: t(
            "common:competition.unlimitedEntries.footnote.text",
            "Event with unlimited entries"
          ),
          iconText: t("common:competition.unlimitedEntries.label", "UL"),
          style: {
            class: "bg-competitionUnlimitedEntriesTag text-white"
          }
        },

        {
          display: competitions.value.some(c =>
            (c.displayChips ?? []).includes("FeiEventWithAirTransport")
          ),
          text: t(
            "common:competition.airplaneTransportation.footnote.text",
            "Air transport and/or early closing date"
          ),
          icon: "$iconPlane",
          style: {
            color: "white",
            class: "bg-competitionAirTransportTag"
          }
        }
      ].filter(x => x.display == true);
    });
    return { tagExplanations };
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        isHighlighted
        isGrandPrix
        displayChips
        isCupFinal
      }
    `
  }
});
</script>
